import { Row, Col } from 'react-bootstrap';
import { Column } from 'primereact/column'
import { useContext, useState, useEffect, useRef } from 'react';
import Card from '../../ui/Card';
import CurrentIssuerMainContact from '../adminCommon/issuerMainContactCurrent';
import NewIssuerMainContact from '../adminCommon/issuerMainContactNew';
import CurrentIssueAuthorizations from '../adminCommon/issueAuthorizationCurrent';
import NewIssueAuthorizations from '../adminCommon/issueAuthorizationNew';
import CurrentAdtrAuthorizations from '../adminCommon/adtrAuthorizationCurrent'; //For RFS
import NewAdtrAuthorizations from '../adminCommon/adtrAuthorizationNew'; //For RFS

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Spinner from 'react-bootstrap/Spinner';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';
import SecurityContainer from '../securityContainer';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { useParams } from "react-router-dom";
import AdminService from "../../../services/AdminService";

const FinalSaleIssuerUpdate = (props) => {
  const user = useContext(UserContext);
  const params= useParams();
  const pageType = params.pageType;

  const currentIssueContactRef = useRef(null);  //pointer to CurrentIssuerMainContact  to refresh grid after adding, approve, reject, or cancel.
  const newIssueContactRef = useRef(null);  //pointer to NewIssuerMainContact to refresh grid after adding, approve, reject, or cancel.
  const currentIssueAuthorizationRef = useRef(null); //pointer to CurrentIssueAuthorizations to refresh grid after adding, approve, reject, or cancel.
  const newIssueAuthorizationRef = useRef(null);  //pointer to NewIssueAuthorizations to refresh grid after adding, approve, reject, or cancel.

  const currentAdtrAuthorizationRef = useRef(null);  //For RFS. pointer to CurrentAdtrAuthorizations to refresh grid after adding, approve, reject, or cancel.
  const newAdtrAuthorizationRef = useRef(null);  //For RFS. pointer to NewAdtrAuthorizations to refresh grid after adding, approve, reject, or cancel.

  const issuerClearRef = useRef(null);
  const contactClearRef = useRef(null);
  const AuthorizationClearRef = useRef(null);
  const contactIdRef = useRef(null);
  const authorizationIdRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [issuers, setIssuers] = useState([]);  //Issuer list
  const [contacts, setContacts] = useState([]); //Contacts list
  const [authorizations, setAuthorizations] = useState([]); //Authorizations list
  const [cdiacNumbers, setCdiacNumbers] = useState([]); //CDIAC Number list

  const [finalSaleId, setFinalSaleId] = useState("");
  const [finalSale, setFinalSale] = useState([]); //Existing current Final Sale with old Issuer Id
  const [newFinalSale, setNewFinalSale] = useState([]); //New Final Sale with new Issuer Id in Review table
  const [issueAuthorizations, setIssueAuthorizations] = useState([]); //Existing issue authorizations in Issue Authorization table
  const [newIssueAuthorizations, setNewIssueAuthorizations] = useState([]); //New issue authorizations in Review table
  const [adtrAuthorizations, setAdtrAuthorizations] = useState([]); //Existing adtr authorizations in Adtr Authorization table
  const [newAdtrAuthorizations, setNewAdtrAuthorizations] = useState([]); //New adtr authorizations in Review table
  const [issuerContact, setIssuerContact] = useState([]); //Existing main issue contact in Issue Contact Assoc table
  const [newIssuerContact, setNewIssuerContact] = useState([]); //New main issue contact in Review table
  const adtrsRef = useRef([]); //Adtr list just for checking for errors

  const [addIssuerError, setAddIssuerError] = useState("");
  const [addIssuerContactError, setAddIssuerContactError] = useState("");
  const [addIssueAuthorizationError, setAddIssueAuthorizationError] = useState("");
  const [addAdtrAuthorizationError, setAddAdtrAuthorizationError] = useState("");
  const [cancelIssuerError, setCancelIssuerError] = useState("");
  
  const [newIssuer, setNewIssuer] = useState([]); //New issuer in Issuer table
  const [newAuthorization, setNewAuthorization] = useState([]); //New authorization in Authorization_Ref table
  const [cdiacNumber, setCdiacNumber] = useState("");
  let reportType = "RFS";
  let tableType = "Review";
  let updateType = "Issuer";
  const reviewHistory = {
    "proposeDebtId": null,
    "finalSaleId": null,
    "updateType" : "Issuer",
    "reviewStatusFlag": "",                        
    "createUser": CommonService.getUserName(user)                        
  }

  const handleCdiacChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    const selectedCdiacNumber = e.length > 0 ? e[0]['cdiacNumber'] : '';
    setFinalSaleId(checkValue);
    setCdiacNumber(selectedCdiacNumber);
    if (checkValue) {
      setAddIssuerError('');
      setCancelIssuerError('');
      setAddIssuerContactError('');
      setAddIssueAuthorizationError('');
      setAddAdtrAuthorizationError('');
      if (pageType === "Update") {
        issuerClearRef?.current?.clear();
        contactClearRef?.current?.clear();
        AuthorizationClearRef?.current?.clear();
      }
      getFinalSaleById(checkValue);
      getNewFinalSaleById(checkValue);
      getAdtrsByFinalSaleId(checkValue);
    }
  }


  const handleIssuerChange = (e, key) => {
      const checkValue = e.length > 0 ? e[0][key] : '';
      if (checkValue) {
        setAddIssuerError('');
        setAddIssueAuthorizationError('');
        setAddAdtrAuthorizationError('');
        if (pageType === "Update") {
          AuthorizationClearRef?.current?.clear();
        }
        getNewIssuer(checkValue);
        getIssuerAuthorizations(checkValue);
      }
    
  }


  const handleContactChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    contactIdRef.current = checkValue;
    setAddIssuerContactError('');
  }


  const handleAuthorizationChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    
    if (checkValue) {
      authorizationIdRef.current = checkValue;
      setAddIssuerError('');
      setAddIssueAuthorizationError('');
      setAddAdtrAuthorizationError('');
      getNewAuthorization(checkValue);
      
    }
  }


  const handleAddIssuerBtn = (e) => {
    if (!finalSaleId) {
      setAddIssuerError('Please select CDIAC number');
      return;
    }
    if (newIssuer?.length === 0) {
      setAddIssuerError('Please select an issuer');
      return;
    }
     if (newIssuer.issuerId === finalSale[0].issuerId) {
      setAddIssuerError('Final Sale already has issuer. Please select a different issuer');
      return;
    }


    setAddIssuerError('');

    //Call backend code to create the new final sale in review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "addNewFinalSaleIssuer",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "finalSale": {
                            "finalSaleId": finalSale[0].finalSaleId,
                            "issuerId": newIssuer.issuerId,
                            "issueName" : finalSale[0].issueName,
                            "issueStatusFlag": finalSale[0].issueStatusFlag,
                            "principalSaleAmt": finalSale[0].principalSaleAmt,
                            "actualSaleDate": finalSale[0].actualSaleDate,
                            "settlementDate": finalSale[0].settlementDate,
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user),
                }
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("New issuer added successfully!");
                    //Also call the backend to get the newly created final sale
                    getNewFinalSaleById(finalSaleId);
                    issuerClearRef?.current?.clear();
                }

            });
    
  }


  const handleAddContactBtn = (e) => {
    if (!finalSaleId) {
      setAddIssuerContactError('Please select CDIAC number');
      return;
    }
    if (newFinalSale?.length === 0) {
      setAddIssuerContactError('Please add an issuer before adding a contact');
      return;
    }
    if (!contactIdRef.current) {
      setAddIssuerContactError('Please select a contact');
      return;
    }


    setAddIssuerContactError('');

    //Call backend code to create the new issue contact assoc in review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "addNewIssueContactIssuerUpdate",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "issueContactAssoc": {
                            "proposeDebtId": issuerContact[0].proposeDebtId,
                            "finalSaleId": issuerContact[0].finalSaleId,
                            "contactId": contactIdRef.current,
                            "roleCodeId" : issuerContact[0].roleCodeId,
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user),
                },
                "reportType" : "RFS",
                "tableType" : "Review"
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("New contact added successfully!");
                    //Also call the backend to get the newly created main contact
                    newIssueContactRef.current.getNewIssueContactById(finalSaleId);
                }

                contactClearRef?.current?.clear();
                contactIdRef.current = '';

            });
    
  }


  const handleAddAuthorizationBtn = (e) => {
    if (!finalSaleId) {
      setAddIssueAuthorizationError('Please select CDIAC number');
      return;
    }
    if (newFinalSale?.length === 0) {
      setAddIssueAuthorizationError('Please add an issuer before connecting Authorization');
      return;
    }
    if (!authorizationIdRef.current) {
      setAddIssueAuthorizationError('Please select an authorization');
      return;
    }
     if (newFinalSale[0].issuerId !== newAuthorization.issuerId) {
      setAddIssueAuthorizationError('Please select an Authorization that belongs to the added issuer');
      return;
    }

    setAddIssueAuthorizationError('');
    
    //Call backend code to bulk create the new issue authorization in review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "postIssueAuthorizationIssuerUpdate", 
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "issueAuthorization": {
                            "proposeDebtId": null,
                            "finalSaleId": newFinalSale[0].finalSaleId,
                            "authorizationId": newAuthorization.authorizationId,
                            "issuerId" : newAuthorization.issuerId,
                            "originalAuthorizedAmt": newAuthorization.authorizationAmt,
                            "authorizationDate": newAuthorization.electionDate,
                            "authorityReplenishAmt": "0.00",
                            "authorityReducedAmt": "0.00",
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user),
                },
                "tableType": tableType,
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Issuer authorization connected successfully!");
                    //Also call the backend to get the newly created authorizations
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(finalSaleId);
                }

                AuthorizationClearRef?.current?.clear();
                authorizationIdRef.current = '';

            });
    
  }


  const handleAddAdtrAuthorizationBtn = (e) => {
    if (finalSaleId === '') {
      setAddAdtrAuthorizationError('Please select CDIAC number');
      return;
    }
    if (newIssueAuthorizations?.length === 0) {
      setAddAdtrAuthorizationError('Selected Report of Final Sale does not have new issue authorizations');
      return;
    }
    if (adtrsRef.current?.length <= 0) {
      setAddAdtrAuthorizationError('Selected Report of Final Sale does not have any adtrs');
      return;
    }
    if (newAdtrAuthorizations?.length > 0) {
      setAddAdtrAuthorizationError('New ADTR Authorizations for Selected Report of Final Sale already exist');
      return;
    }

    setAddAdtrAuthorizationError('');

    //Call backend code to bulk create the new authorizations
    var obj = {
            msgId: null,
            sysId: null,
            opr: "addAdtrAuthorizations",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "adtrAuth": {"adtrId": 0,
                            "authorizationId": 0,
                            "beginAmt" : 0.00,
                            "lapsedAmt": 0.00,
                            "duringAmt": 0.00,
                            "authorityReplenishAmt": 0.00,
                            "authorityReducedAmt": 0.00,
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user)
                },
                "finalSaleId" : finalSaleId,
                "updateType" : updateType
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("ADTR Authorizations added successfully!");
                    //Also call the backend to get the newly created authorizations
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }



  const handleCancelChangesBtn = (e) => {
    if (finalSaleId === '') {
      setCancelIssuerError('Please select CDIAC number');
      return;
    }
    if (newFinalSale?.length === 0) {
      setCancelIssuerError('Selected Report of Final Sale does not have any changes to cancel');
      return;
    }

    setCancelIssuerError('');

    //Call backend code to cancel all data for the selected propose Debt report from the review tables
    var obj = {
            msgId: null,
            sysId: null,
            opr: "cancelRejectFinalSaleIssuerUpdate",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "finalSaleId" : finalSaleId
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Changes cancelled successfully!");
                    //Also call the backend to refresh new grids to show that cancelled review data have been deleted
                    getNewFinalSaleById(finalSaleId);
                    newIssueContactRef.current.getNewIssueContactById(finalSaleId);
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(finalSaleId);
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }


  const handleApproveIssuerUpdateBtn = (e) => {
    if (finalSaleId === '') {
      setAddIssuerError('Please select CDIAC number');
      return;
    }
    if (newFinalSale?.length === 0) {
      setAddIssuerError('Selected Report of Final Sale does not have any New Issuer to approve');
      return;
    }
    if (newIssuerContact?.length === 0) {
      setAddIssuerError('Selected Report of Final Sale does not have any New Main Contact to approve');
      return;
    }
    if (newIssueAuthorizations?.length === 0) {
      setAddIssuerError('Selected Report of Final Sale does not have any New Issuer Authorizations to approve');
      return;
    }
     if (adtrsRef.current?.length > 0 && newAdtrAuthorizations?.length === 0) {
      setAddIssuerError('Selected Report of Final Sale is missing New Adtr Authorizations to approve');
      return;
    }

    setAddIssuerError('');

    //Call backend code to save the new approved issuer and related data in Final Sale and other tables and delete them from the review tables
    var obj = {
            msgId: null,
            sysId: null,
            opr: "approveFinalSaleIssuerReview",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "newFinalSale": newFinalSale,
                "newIssuerContact": newIssuerContact,  //New main issue contact in Review table
                "newIssueAuthorizations": newIssueAuthorizations,  //New issue authorizations in Review table 
                "newAdtrAuthorizations" : newAdtrAuthorizations  //New adtr authorizations in Review table
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Approval of Issuer update was successful!");
                     //Create Review History data
                    reviewHistory.finalSaleId = finalSaleId;
                    reviewHistory.reviewStatusFlag = "A";
                    AdminService.saveReviewHistory(reviewHistory);
                    //Also call the backend to refresh all grids to reflect the aprroved issuer update
                    getFinalSaleById(finalSaleId);
                    getNewFinalSaleById(finalSaleId);
                    currentIssueContactRef.current.getIssueContactById(finalSaleId);
                    newIssueContactRef.current.getNewIssueContactById(finalSaleId);
                    currentIssueAuthorizationRef.current.getIssueAuthorizationsByReportId(finalSaleId);
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(finalSaleId);
                    currentAdtrAuthorizationRef.current.getAuthorizationsByRFSId(finalSaleId);
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }


  const handleRejectIssuerUpdateBtn = (e) => {
    if (finalSaleId === '') {
      setAddIssuerError('Please select CDIAC number');
      return;
    }
    if (newFinalSale?.length === 0) {
      setAddIssuerError('Selected Report of Final Sale does not have New Issuer to reject');
      return;
    }

    setAddIssuerError('');

    //Call backend code to delete the rejected new data from the review tables
    var obj = {
            msgId: null,
            sysId: null,
            opr: "cancelRejectFinalSaleIssuerUpdate",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                 "finalSaleId" : finalSaleId,
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Rejection of Issuer update was successful!");
                    //Create Review History data
                    reviewHistory.finalSaleId = finalSaleId;
                    reviewHistory.reviewStatusFlag = "R";
                    AdminService.saveReviewHistory(reviewHistory);
                    //Also call the backend to refresh new grids to show that rejected review data have been deleted
                    getNewFinalSaleById(finalSaleId);
                    newIssueContactRef.current.getNewIssueContactById(finalSaleId);
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(finalSaleId);
                    newAdtrAuthorizationRef.current.getNewAuthorizationsByRFSId(finalSaleId);
                }

            });
    
  }


  useEffect(() => {
    getCdiacNumbers();
    getIssuers();
    getContacts();
  }, []);


  const getCdiacNumbers = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getCdiacFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "updateType": "Issuer"
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setCdiacNumbers(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getIssuers = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getIssuers",
      hdrStruct: null,
      queryParam: null,
      reqData: {},
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setIssuers(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getContacts = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAllContacts",  //Also used in updateAdtr/editAdtr component
      hdrStruct: null,
      queryParam: null,
      reqData: {},
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setContacts(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }
  

const getIssuerAuthorizations = (selectedIssuerId) => {   //Get list of authorizations for the selected Issuer or new final sale issuer.
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAuthorizationRefsByIssuerId",  
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "issuerId": selectedIssuerId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAuthorizations(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getNewIssuer = (selectedIssuerId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getIssuerByIssuerId",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "issuerId": selectedIssuerId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setNewIssuer(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getNewAuthorization = (selectedAuthorizationId) => {  //Get detail information on the selected authorization used for add issuer authorization in review table.
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAuthorizationRef",  //Existing operation
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "authorizationId": selectedAuthorizationId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setNewAuthorization(result.data.responses[key]);
        });
        setIsLoading(false);
      });

  }


  const getFinalSaleById = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getFinalSaleById",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "finalSaleId": selectedFinalSaleId,
        "tableType": "Normal",
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setFinalSale(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }


  const getNewFinalSaleById = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getFinalSaleById",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "finalSaleId": selectedFinalSaleId,
        "tableType": "Review",
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
          const respondData = result.data.responses[0];
          getIssuerAuthorizations(respondData[0]?.issuerId);
          setNewFinalSale(respondData);
          setIsLoading(false);
          
        
      });
  }


  const getAdtrsByFinalSaleId = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrByFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
          "finalSaleId": selectedFinalSaleId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        adtrsRef.current = result.data.responses;
        setIsLoading(false);
      });
  }


  const columnsFinalSale = [{
    dataField: 'issuerName',
    text: 'Issuer Name',
    sort: true,
  },{
    dataField: 'principalSaleAmt',
    text: 'Principal Sale Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.principalSaleAmt),
  },{
    dataField: 'actualSaleDate',
    text: 'Actual Sale Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.actualSaleDate),
  },{
    dataField: 'settlementDate',
    text: 'Settlement Sale Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.settlementDate),
  },{
    dataField: 'issueName',
    text: 'Issue Name',
    sort: true,
  },
  ];


  const  columnsNewFinalSale = [{
    dataField: 'issuerName',
    text: 'Issuer Name',
    sort: true,
  },{
    dataField: 'principalSaleAmt',
    text: 'Principal Sale Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.principalSaleAmt),
  },{
    dataField: 'actualSaleDate',
    text: 'Actual Sale Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.actualSaleDate),
  },{
    dataField: 'settlementDate',
    text: 'Settlement Sale Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.settlementDate),
  },{
    dataField: 'issueName',
    text: 'Issue Name',
    sort: true,
  },
  ];


  return (
    <SecurityContainer>
      <form onSubmit={(e) => e.preventDefault()}>
        <Card>
          <div className="panel panel-default">
            <div className="panel-heading">
              <div className="container">
                <div id="packet_id" className="panel-title">
                  {pageType === "Update" && <h1 className="menu-title">Final Sale Issuer Update</h1>}
                  {pageType === "Review" && <h1 className="menu-title">Final Sale Issuer Update Review</h1>}
                </div>
              </div>
            </div>
            <div className="panel-body">
              <div className="container">
                <div className="form">
                  {isLoading && <Spinner animation="border" variant="primary" />}
                  <Row>
                    <Col md={12}>
                      <div className="control">
                        <label>CDIAC Number: </label>
                        <Typeahead
                          placeholder="Choose CDIAC Number"
                          id="finalsale"
                          labelKey="cdiacNumber"
                          onChange={e => handleCdiacChange(e, "finalSaleId")}
                          inputProps={{ 'data-validations': 'required', name: 'cdiacNumber' }}
                          options={cdiacNumbers}
                          sort
                        />
                      </div>
                    </Col>
                    
                  </Row>

                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div>
                        <a href="/admin" className="dk-blue-color link-button" style={{ float: 'left' }}>Back to Admin</a>
                      </div>
                      <div style={{ float: 'right' }}>
                        <div>
                          {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleCancelChangesBtn} >
                            Cancel All Changes
                          </button>}
                        </div>
                      </div>
                    </div>
                    <div style={{ float: 'right' }}>
                      <p className="error"> {cancelIssuerError}</p>
                    </div>
                  </div>

                  <hr />

                  {/* Final Sale grid */}
                  <Row>
                    {pageType === "Update" && <Col md={12}>
                      <div className="control">
                        <label>Issuer: </label>
                        <Typeahead
                          placeholder="Choose an Issuer"
                          id="issuerId"
                          labelKey="issuerName"
                          onChange={e => handleIssuerChange(e, "issuerId")}
                          inputProps={{ 'data-validations': 'required', name: 'issuerId' }}
                          options={issuers}
                          sort
                          ref={issuerClearRef}
                        />
                      </div>

                    </Col>}
                  </Row>
                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div style={{ float: 'right' }}>
                        <div>
                          {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddIssuerBtn} >
                            Add New Issuer
                          </button>}
                        </div>
                      </div>
                    </div>
                    <div style={{ float: 'right' }}>
                     {pageType === "Update" &&  <p className="error"> {addIssuerError}</p>}
                    </div>
                  </div>
                  <div>
                    <DataGrid
                      title="Current Final Sale:"
                      dataSource={finalSale}
                      sortField='finalSaleId'
                      showQuickSearch={false}
                      emptyDataMessage='No data available to display'
                    >
                      {columnsFinalSale.map((column, i) => {
                        return (
                          <Column
                            key={i}
                            field={column.dataField}
                            header={column.text}
                            body={column.formatter}
                            hidden={column.hidden}
                          />)
                      })
                      }
                    </DataGrid>
                  </div>
                  <div>
                    <DataGrid
                      title="New Final Sale:"
                      dataSource={newFinalSale}
                      sortField='finalSaleId'
                      showQuickSearch={false}
                      emptyDataMessage='No data available to display'
                    >
                      {columnsNewFinalSale.map((column, i) => {
                        return (
                          <Column
                            key={i}
                            field={column.dataField}
                            header={column.text}
                            body={column.formatter}
                            hidden={column.hidden}
                          />)
                      })
                      }
                    </DataGrid>
                  </div>

                  <hr />

                  {/* Contact Section */}
                  <div>
                    <div>
                      {pageType === "Update" && <Row>
                        <Col md={12}>
                          <div className="control">
                            <label>Contact: </label>
                            <Typeahead
                              placeholder="Choose a Contact"
                              id="contactId"
                              labelKey="contactFullName"
                              onChange={e => handleContactChange(e, "contactId")}
                              inputProps={{ 'data-validations': 'required', name: 'contactId' }}
                              options={contacts}
                              sort
                              ref={contactClearRef}
                            />
                          </div>
                        </Col>
                      </Row>}
                      <div style={{ overflow: 'auto' }}>
                        <div className="fleft w-100">
                          <div style={{ float: 'right' }}>
                            <div>
                              {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddContactBtn} >
                                Add New Contact
                              </button>}
                            </div>
                          </div>
                        </div>
                        <div style={{ float: 'right' }}>
                          <p className="error"> {addIssuerContactError}</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <CurrentIssuerMainContact
                        onDataFetch={setIssuerContact}
                        reportId={finalSaleId}
                        reportType={reportType}
                        ref={currentIssueContactRef}
                      />
                    </div>
                    <div>
                      <NewIssuerMainContact
                        onDataFetch={setNewIssuerContact}
                        reportId={finalSaleId}
                        reportType={reportType}
                        ref={newIssueContactRef}
                      />
                    </div>
                  </div>

                  <hr />

                  {/* Issue Authorization Section */}
                  <div>
                    <div>
                      {pageType === "Update" && <Row>
                        <Col md={12}>
                          <div className="control">
                            <label>Authorization: </label>
                            <Typeahead
                              placeholder="Choose an Authorization"
                              id="authorizationId"
                              labelKey="authorizationFullName"
                              onChange={e => handleAuthorizationChange(e, "authorizationId")}
                              inputProps={{ 'data-validations': 'required', name: 'authorizationId' }}
                              options={authorizations}
                              sort
                              ref={AuthorizationClearRef}
                            />
                          </div>

                        </Col>
                      </Row>}
                      <div style={{ overflow: 'auto' }}>
                        <div className="fleft w-100">
                          <div style={{ float: 'right' }}>
                            <div>
                              {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddAuthorizationBtn} >
                                Connect Authorizations
                              </button>}
                            </div>
                          </div>
                        </div>
                        <div style={{ float: 'right' }}>
                          <p className="error"> {addIssueAuthorizationError}</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <CurrentIssueAuthorizations
                        onDataFetch={setIssueAuthorizations}
                        reportId={finalSaleId}
                        reportType={reportType}
                        tableType={"Normal"}
                        ref={currentIssueAuthorizationRef}
                      />
                    </div>
                    <div>
                      <NewIssueAuthorizations
                        cdiacNumber={cdiacNumber}
                        onDataFetch={setNewIssueAuthorizations}
                        reportId={finalSaleId}
                        reportType={reportType}
                        tableType={"Review"}
                        ref={newIssueAuthorizationRef}
                      />
                    </div>
                  </div>

                  {/* ADTR Authorization Section */}

                  <hr />

                  <div>
                    <div>
                      <div style={{ overflow: 'auto' }}>
                        <div className="fleft w-100">
                          <div style={{ float: 'right' }}>
                            <div>
                              {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddAdtrAuthorizationBtn} >
                                Connect ADTR Authorizations
                              </button>}
                            </div>
                          </div>
                        </div>
                        <div style={{ float: 'right' }}>
                          <p className="error"> {addAdtrAuthorizationError}</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <CurrentAdtrAuthorizations
                        onDataFetch={setAdtrAuthorizations}
                        reportId={finalSaleId}
                        ref={currentAdtrAuthorizationRef}
                      />
                    </div>
                    <div>
                      <NewAdtrAuthorizations
                        cdiacNumber={cdiacNumber}
                        onDataFetch={setNewAdtrAuthorizations}
                        reportId={finalSaleId}
                        updateType="Issuer"
                        ref={newAdtrAuthorizationRef}
                      />
                    </div>
                  </div>
                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div className="fleft w-50" style={{ float: 'right' }}>
                        {pageType === "Review" && <button className="custom-button bg-success text-light rounded" style={{ float: 'left' }} onClick={handleApproveIssuerUpdateBtn} >
                          Approve
                        </button>}
                        {pageType === "Review" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleRejectIssuerUpdateBtn} >
                          Reject
                        </button>}
                      </div>
                    </div>
                    <div style={{ float: 'right' }}>
                      {pageType === "Review" && <p className="error"> {addIssuerError}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </form>
    </SecurityContainer>

  )
}

export default FinalSaleIssuerUpdate
